import $ from 'jquery';
import {Swiper, Autoplay, Pagination, Navigation} from 'swiper/js/swiper.esm.js';
Swiper.use([Autoplay, Pagination, Navigation]);

import {gallerySwiper} from './gallery-slider.js';


$('.open-lightbox').on('click', function(event){
	event.preventDefault();

	const $self = $(this);
	const $section = $self.closest('section');
	const $lightbox = $section.find('.lightbox');

	$lightbox.addClass('show');
	$('body').addClass('no-scroll');

	let lightboxSwiper = $lightbox[0].swiper;

	if( lightboxSwiper === undefined ){
		lightboxSwiper = new Swiper($lightbox.find('.lightbox-slider')[0], {
			keyboard: {
				enabled: true,
			},
			loop: true,
			navigation: {
				prevEl: '.lightbox-slider .swiper-button-prev',
				nextEl: '.lightbox-slider .swiper-button-next',
			},
		});
		$lightbox.addClass('initialized');
	}

	console.log('swiper', lightboxSwiper);

	const slideIndex = Number($self.attr('data-index')) + 1;

	lightboxSwiper.slideTo( slideIndex );
});


$('.lightbox .close').on('click', function(){
	$('.lightbox').removeClass('show');
	$('body').removeClass('no-scroll');
});



$(document).on('keyup', function(e) {
	if( e.key === 'Escape' ){
		$('.lightbox').removeClass('show');
		$('body').removeClass('no-scroll');
	}
});

